export class HelpFormDTO {
  fullName: string;
  email: string;
  phone: string;
  issueDescription: string;

  constructor() {
    this.fullName = '';
    this.email = '';
    this.phone = '';
    this.issueDescription = '';
  }
}
